const getTenor = (months: number) => {
    const years = Math.floor(months / 12);
    const monthsRemainder = months % 12;
    return { years, monthsRemainder };
};

export const formatYearsAndMonths = (months: number, translate: (key: string) => string) => {
    const { years, monthsRemainder } = getTenor(months);
    if (years > 0 && monthsRemainder > 0) {
        return `${years} ${translate('field.toggle.years')}, ${monthsRemainder} ${translate('field.months.label')}`;
    }
    if (years > 0 && monthsRemainder === 0) {
        return `${years} ${translate('field.toggle.years')}`;
    }
    if (years === 0 && monthsRemainder > 0) {
        return `${monthsRemainder} ${translate('field.months.label')}`;
    }
    return `0 ${translate('field.months.label')}`;
};
